// extracted by mini-css-extract-plugin
module.exports = {"fallbackContainer":"AppTopBar_fallbackContainer__3DwwP","userMenu":"AppTopBar_userMenu__3X-Xx","topBarShopName":"AppTopBar_topBarShopName__1uFQH"};